var _circle, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCgenderimage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#006779"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 21.25C26.9853 21.25 29 19.2353 29 16.75C29 14.2647 26.9853 12.25 24.5 12.25C22.0147 12.25 20 14.2647 20 16.75C20 19.2353 22.0147 21.25 24.5 21.25Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M31.25 20.125C33.114 20.125 34.625 18.8658 34.625 17.3125C34.625 15.7592 33.114 14.5 31.25 14.5",
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.75 20.125C15.886 20.125 14.375 18.8658 14.375 17.3125C14.375 15.7592 15.886 14.5 17.75 14.5",
    stroke: "white",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 33.625C28.2279 33.625 31.25 31.6103 31.25 29.125C31.25 26.6397 28.2279 24.625 24.5 24.625C20.7721 24.625 17.75 26.6397 17.75 29.125C17.75 31.6103 20.7721 33.625 24.5 33.625Z",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M33.5 31.375C35.4735 30.9422 36.875 29.8462 36.875 28.5625C36.875 27.2788 35.4735 26.1828 33.5 25.75",
    stroke: "white",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M15.5 31.375C13.5265 30.9422 12.125 29.8462 12.125 28.5625C12.125 27.2788 13.5265 26.1828 15.5 25.75",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCgenderimage);
export default __webpack_public_path__ + "static/media/cgenderimage.5c2c9a27debffcc71ad5fef564c51770.svg";
export { ForwardRef as ReactComponent };